import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":_vm.$t('Weekdays'),"items":_vm.items,"item-value":"value","item-text":"text","multiple":"","chips":"","outlined":"","deletable-chips":""},model:{value:(_vm.weekdays),callback:function ($$v) {_vm.weekdays=$$v},expression:"weekdays"}})}
var staticRenderFns = []

export { render, staticRenderFns }